import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-delete-paddock',
    templateUrl: './delete-paddock.component.html',
    styleUrls: ['./delete-paddock.component.css'],
    standalone: true,
    imports: [CommonModule, MatDialogModule]
})
export class DeletePaddockComponent implements OnInit {
  paddockName = inject(MAT_DIALOG_DATA);


  ngOnInit(): void {
  }

}
